/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * @flow
 */
import {AbstractCrudObject} from './../abstract-crud-object';

/**
 * FriendList
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */
export default class FriendList extends AbstractCrudObject {
  static get Fields () {
    return Object.freeze({
      id: 'id',
      list_type: 'list_type',
      name: 'name',
      owner: 'owner',
    });
  }


  
  get (fields: Array<string>, params: Object = {}): FriendList {
    // $FlowFixMe : Support Generic Types
    return this.read(
      fields,
      params
    );
  }
}
